export default "__VITE_ASSET__BOlfRDoh__"